<!--
    @首页-今日开标项目
-->
<template>
    <div class="item">
        <div class="item-top">
            <img class="open-bg" :src="require('@/assets/images/open-bg.png')" alt="">
            <div class="item-title">
                <span :title="`[${item.tradePlatfBidSectionCode}] ${item.bidName}`">[{{item.tradePlatfBidSectionCode}}] {{item.bidName}}</span>
                <div class="item-tag">
                    <span class="defult-status" :class="status.bid.tagClass">
                        <span class="ing-icon" v-if="item.status == 2"></span>{{status.bid.text}}</span>
                    <span class="defult-status" :class="status.eval.tagClass">
                        <span class="ing-icon" v-if="item.evalStatus == 3"></span>{{status.eval.text}}</span>
                </div>
            </div>
            <div class="item-row">
                <span class="defult-tag tag-zhao">招</span>
                <span class="name" :title="item.tendererName">{{item.tendererName}}</span>
            </div>
            <div class="item-row">
                <span class="defult-tag tag-dai">代</span>
                <span class="name" :title="item.agencyName">{{item.agencyName}}</span>
            </div>
        </div>
        <div class="item-bottom">
            <span :title="item.bidopenTime"><img :src="require('@/assets/images/icon-time.png')" alt="">{{item.bidopenTime}}</span>
            <span :title="item.bidRoomName" v-if="item.bidRoomName"><i class="el-icon-location-outline" style="font-size: 16px;"></i>{{item.bidRoomName}}</span>
        </div>
        <div class="open-mask">
            <div class="open-mask--mask"></div>
            <div class="open-mask--btn">
                <span title="点击进入" @click="status.bid.handler">{{status.bid.btnText}}</span>
                <span title="点击进入" @click="status.eval.handler">{{status.eval.btnText}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            require: true
        }
    },
    computed: {
        status() {
            let evalStatusEnum = [ //评标
                {text: '等待评标',value: '1',tagClass:null,btnText:'评标视频见证',handler:this.evalEnter},
                {text: '评标准备中',value: '2',tagClass:null,btnText:'评标视频见证',handler:this.evalEnter},
                {text: '评标中',value: '3',tagClass:'ing-status',btnText:'评标视频见证',handler:this.evalEnter},
                {text: '已流标',value: '4',tagClass:null,btnText:'评标见证记录',handler:this.evalEnter},
                {text: '评标结束',value: '5',tagClass:'end-status',btnText:'评标见证记录',handler:this.evalEnter}
            ];
            let openStatusEnum = [ //不见面
                {text: '待开标',value: 0,tagClass:null,btnText:'开标视频见证',handler:this.bidEnter},
                {text: '待开标',value: 1,tagClass:null,btnText:'开标视频见证',handler:this.bidEnter},
                {text: '开标中',value: 2,tagClass:'ing-status',btnText:'开标视频见证',handler:this.bidEnter},
                {text: '取消开标',value: 3,tagClass:null,btnText:'开标视频见证',handler:this.bidEnter},
                {text: '开标流标',value: 4,tagClass:null,btnText:'开标视频见证',handler:this.bidEnter},
                {text: '开标结束',value: 5,tagClass:'end-status',btnText:'开标见证记录',handler:this.bidEnter},
            ]
            let obj = {
                bid: {},
                eval: {}
            };
            for (const item of evalStatusEnum) {
                if(item.value === this.item.evalStatus) {
                    obj.eval = {
                        text: item.text,
                        tagClass: item.tagClass,
                        btnText: item.btnText,
                        handler: item.handler
                    }
                }
            }
            for (const item of openStatusEnum) {
                if(item.value === this.item.openStatus) {
                    obj.bid = {
                        text: item.text,
                        tagClass: item.tagClass,
                        btnText: item.btnText,
                        handler: item.handler
                    }
                }
            }
            return obj;
        }
    },
    methods: {
        bidEnter() {
            let bidList = [0,1,2,3,4];
            if(bidList.indexOf(this.item.openStatus) !=-1) {
                this.$router.push({
                    path: this.item.openVideoUrl
                })
            }else {
                this.$router.push({
                    path: this.item.openRecordUrl
                    // name: 'openBidAndEstimateWitness_beginList'
                })
            }
        },
        evalEnter() {
            let evalList = ['1','2','3'];
            if(evalList.indexOf(this.item.evalStatus) !=-1) {
                this.$router.push({
                    path: this.item.evalVideoUrl
                })
            }else {
                this.$router.push({
                    path: this.item.evalRecordUrl
                })
            }
        }
    }
}
</script>

<style lang="less" scoped>
.item {
    //max-width: 370px;
    width: calc(50% - 8px);
    height: 162px;
    border: 1px solid #E8E8E8;
    border-radius: 4px 4px 4px 4px;
    background: #fff;
    //margin-right: 16px;
    margin-bottom: 16px;
    overflow: hidden;
    position: relative;
    width: 100%;
    &:hover {
        box-shadow: 0px 0px 8px 0px rgba(72,92,109,0.2);
    }
    &:hover .open-mask {
        display: block;
    }
    &:nth-child(2n) {
        margin-right: 0;
    }
    &:last-child,&:nth-last-child(2) {
        margin-bottom: 0;
    }
    .item-top {
        height: calc(100% - 28px);
        padding: 12px 0 0 16px;
        position: relative;
        overflow: hidden;
        .open-bg {
            position: absolute;
            bottom: -27px;
            right: 0;
        }
        .item-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            >span {
                font-weight: 600;
                color: #000000;
                width: calc(100% - 90px);
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                line-height: 22px;
            }
            .item-tag {
                margin-left: 14px;
                text-align: right;
                max-width: 80px;
                // width: 80px;
                // display: flex;
                // flex-direction: column;
                .defult-status:nth-child(1) {
                    margin-bottom: 6px;
                }
            }
        }
        .item-row {
            margin-top: 8px;
            display: flex;
            .name {
                color: #7390AB;
                margin-left: 8px;
                display: inline-block;
                overflow: hidden;/*超出部分隐藏*/
                text-overflow:ellipsis;/* 超出部分显示省略号 */
                white-space: nowrap;/*规定段落中的文本不进行换行 */
                width: calc(100% - 30px);/*需要配合宽度来使用*/
            }
        }
    }
    .item-bottom {
        font-weight: 400;
        color: #7390AB;
        padding: 6px 12px 6px 13px;
        position: relative;
        z-index: 20;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
            display: flex;
            align-items: center;
            img {
                margin-right: 4px;
                vertical-align: middle;
            }
            &:nth-child(2) {
                max-width: 150px;
                overflow: hidden;/*超出部分隐藏*/
                text-overflow:ellipsis;/* 超出部分显示省略号 */
                white-space: nowrap;/*规定段落中的文本不进行换行 */
            }
        }
        &:before {
            content: '';
            width: 100%;
            height: 1px;
            background-color: #E8E8E8;
            position: absolute;
            top: 0;
            left: 0;
        }
    }
    .open-mask {
        display: none;
        width: 100%;
        height: 54px;
        position: absolute;
        bottom: 0;
        left: 0;
        color: #FFFFFF;
        z-index: 90;
        .open-mask--mask {
            width: 100%;
            height: 100%;
            position: absolute;
            background: rgba(0,0,0,0.65);
            backdrop-filter: blur(2px);
        }
        .open-mask--btn {
            width: 100%;
            height: 100%;
            padding: 10px 0;
            position: relative;
            z-index: 10;
            display: flex;
            align-items: center;
            span {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
                flex: 1;
                cursor: pointer;
                &:hover {
                    opacity: .8;
                }
                &:nth-child(1) {
                    border-right: 1px solid #FFFFFF;
                }
            }
        }
    }
}
</style>
